import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import Modal from "../modal";

import "./messageModalStyles.css";

const MessageModal = ({
  displayModal,
  setDisplayModal,
  title,
  message,
  buttonText,
  buttonHandler,
  footerText = "",
}) => {
  const onClickButton = () => {
    if (buttonHandler) {
      buttonHandler();
    }
    setDisplayModal(false);
  };

  const getBodyContent = () => (
    <Container
      className={`message-modal ${footerText.length > 0 ? "mw-100" : "mw-75"}`}
    >
      <Row className="text-center my-2">
        <Col xs={12}>
          <span className="message-body">{message}</span>
        </Col>
      </Row>
      <Row className="text-center mt-3">
        <Col xs={12}>
          <button className="confirm-button" onClick={onClickButton}>
            {buttonText}
          </button>
        </Col>
      </Row>
      {footerText.length > 0 && (
        <Row className="text-center my-2">
          <Col xs={12}>
            <span className="message-footer">{footerText}</span>
          </Col>
        </Row>
      )}
    </Container>
  );

  return (
    <Modal
      size="md"
      title={title}
      bodyContent={getBodyContent()}
      showFooter={false}
      displayModal={displayModal}
      setDisplayModal={setDisplayModal}
    />
  );
};

export default MessageModal;
